<template>
  <div class="gallery-uploader-grid">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "GalleryUploaderGrid",
})
</script>

<style scoped>
.gallery-uploader-grid {
  display: grid;
  grid-gap: 16px;
  grid-template-columns: repeat(auto-fill, 128px);
  grid-auto-rows: minmax(min-content, max-content);

  transition: 300ms;
}
</style>
